import React, { useEffect, useState } from 'react';
import Header from '@components/Comman/Header';
import { Table, Tag, Button, Space, Modal, Input, Row, Col, Select } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { capitalizeAfterComma, capitalizeFirstLetter, formatAndCapitalizeString, getExistingBusinessCode, isValidEmail, truncateText } from '@utils/comman';
import { getAllBusinessCategories, getReferUsNetworkBusinesses } from '../../actions/business';
// import { businessCategories } from '@utils/contstant';
import { getAllAdminNotificationCount, updateReferrerNotificationCount } from '../../actions/refer';

interface DataType {
    key: string;
    firstName: string;
    lastName: string;
    email: string;
    businessCode: string;
    isRegistered: boolean;
}

interface ReferrerType {
    adminId?: number
}

interface PayloadType {
    limit: number;
    page: number;
    role: number;
    admin_id?: number;
};

const ReferUsNetworkList = ({ adminId }: ReferrerType) => {
    const [data, setData] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState({ totalItems: 0 });
    const [showConfirm, setShowConfirm] = useState(false)
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const userData = useSelector((state: any) => state?.Auth?.user);
    const businessList = useSelector((state: any) => state?.Business?.businessDetails);
    const userRoleId = userData?.data?.roleId;
    const { isLoading } = useSelector((state: any) => state?.General);
    const [searchValues, setSearchValues] = useState({ businessName: '', category: '', postcode: '', otherCategory : '' });
    const { businessCategory } = useSelector((state:any) => state?.Business)


    const getBusinessIReferData =(payloadD: any)=> {
        let payload = { limit: pageSize, page, ...payloadD };

        if (userRoleId === 1) {
            payload = { ...payload, admin_id: adminId }
        }
        dispatch(
            getReferUsNetworkBusinesses(payload, (resp: any) => {
                if (resp?.status === 200) {
                    setData(resp?.data);
                    setPagination(resp?.pagination);
                }
            })
        );
    }

    useEffect(() => {
        let payload: PayloadType = { limit: pageSize, page, role: userRoleId };
        getBusinessIReferData(payload);
    }, [page, pageSize, dispatch]);

    useEffect(()=> {
        dispatch(updateReferrerNotificationCount({resetType: 'referUs Network', role: userRoleId }, (res:any)=>{
            dispatch(getAllAdminNotificationCount({}, (res:any)=>{}))
        }))
        dispatch(getAllBusinessCategories({}, ()=>{}))
    }, [])


    const handleTableChange = (pagination: any) => {
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const columns: ColumnsType<DataType> = [
        {
            title: 'Business Name',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            render: (text) => {
            return <>{text?.businessName}</>
            },
            align: 'left',
            width: 130,
        },
        {
            title: 'Description',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            render: (text) => {
                return <span title={text?.description}>{
                  text?.description && truncateText(capitalizeFirstLetter(capitalizeAfterComma(text?.description)))
                }</span>
            },
            align: 'left',
            width: 150,
        },
        {
            title: 'Category',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            sorter: (a: any, b: any) => a?.BusinessDetails?.category?.localeCompare(b?.BusinessDetails?.category),
            render: (text) => <>{capitalizeFirstLetter(formatAndCapitalizeString(text?.category))}</>,
            align: 'center',
            width: 100,
        },
        {
            title: 'PostCode',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            sorter: (a: any, b: any) => a?.BusinessDetails?.pinCode?.localeCompare(b?.BusinessDetails?.pinCode),
            render: (text) => <a href={`https://auspost.com.au/postcode/${text?.pinCode}`} title={'Click to view this postcode on Australiya Post'} target='_blank'>{text?.pinCode}</a>,
            align: 'center',
            width: 100,
        },
        {
            title: 'State',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            sorter: (a: any, b: any) => a?.BusinessDetails?.state?.localeCompare(b?.BusinessDetails?.state),
            render: (text) => <>{text?.state}</>,
            align: 'center',
            width: 100,
        },
        {
            title: 'Country',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            sorter: (a: any, b: any) => a?.BusinessDetails?.country?.localeCompare(b?.BusinessDetails?.country),
            render: (text) => <>{text?.country}</>,
            align: 'center',
            width: 100,
        },
        {
            title: 'Promotion Page',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            sorter: (a: any, b: any) => a?.BusinessDetails?.url?.localeCompare(b?.BusinessDetails?.url),
            render: (text) => <a href={text?.url} target='_blank' title={'Promotional Page Link'}><LinkOutlined style={{ fontSize: '20px' }} /></a>,
            align: 'center',
            width: 100,
        },
        {
            title: 'Become A Referrer',
            key: '',
            render: (_, record: any) => {
              return <Space size="middle">
                    {userRoleId !== 1  ? getExistingBusinessCode(record?.invite)?.length === 0 ?
                        <Button
                            type="primary"
                            className='btn btn-primary-md'
                            size='small'
                            onClick={() => {console.log(record);setShowConfirm(true)}}
                        >
                            Become A Referrer
                        </Button>
                        : <Tag color="#87d068" style={{ height: '30px', color: 'white', padding: '0 10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            Active
                        </Tag>
                         : <Tag color="#87d068" style={{ height: '30px', color: 'white', padding: '0 10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            Active
                        </Tag>}
              </Space>
            },
            align: 'center',
            width: 120,
        },
    ];


    const handleSearch =()=> {
        let values = {...searchValues};
        if(values.category == 'other'){
           values.category = values.otherCategory;
        }
        delete values.otherCategory;
        getBusinessIReferData(values);
    }

    const handleReset = () => {
        setSearchValues({
            businessName: '', category: '', postcode: '', otherCategory : ''
        });
        getBusinessIReferData({});
    };

    const tableComponent = (
        <>
            <div className="responsivetable">
                <Table
                    size='small'
                    columns={columns}
                    dataSource={data}
                    loading={isLoading}
                    pagination={{
                        total: pagination?.totalItems || 0,
                        pageSize,
                        current: page,
                        showSizeChanger: true,
                        pageSizeOptions: ['20', '50'],
                    }}
                    scroll={{ y: 264, x: 800 }}
                    onChange={handleTableChange}
                    rowKey='email'
                />
            </div>

        </>
    );

    return (
        <div>
            <Header pagTitle="ReferUs Network" />
            <div className="contentBody">
                <div className="bodycard">
                    <div className='d-flex'>
                        <Row gutter={[16, 16]} style={{ marginBottom: '16px', width: '100%' }}>
                            {/* Business Name Input */}
                            <Col span={6}>
                                <Input
                                    placeholder="Enter business name"
                                    value={searchValues.businessName}
                                    style={{ height: '50px', marginBottom: '16px' }}
                                    onChange={(e) => setSearchValues({ ...searchValues, businessName: e?.target?.value })}
                                />
                            </Col>

                            {/* Business Category Select */}
                            <Col span={6}>
                                <Select
                                    value={searchValues?.category || undefined} // Ensure this is undefined when no selection
                                    allowClear // Enable clear option
                                    style={{ width: '100%', height: '50px', marginBottom: '16px' }}
                                    onChange={(e) => setSearchValues({ ...searchValues, category: e })}
                                    placeholder="Business Category"
                                >
                                    {businessCategory?.map((item:any, index:number) => (
                                        <Select.Option key={index} value={item?.value}>
                                            {item.label}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Col>
                            {/* Conditionally render the Other Category input */}
                            {searchValues.category === 'other' && (
                                <Col span={6}>
                                <Input
                                    placeholder="Enter other business category"
                                    value={searchValues.otherCategory}
                                    style={{ height: '50px', marginBottom: '16px' }}
                                    onChange={(e) => setSearchValues({ ...searchValues, otherCategory: e.target.value })}
                                />
                                </Col>
                            )}

                            {/* Postcode Input */}
                            <Col span={6}>
                                <Input
                                    placeholder="PostCode"
                                    value={searchValues.postcode}
                                    style={{ height: '50px', marginBottom: '16px' }}
                                    onChange={(e) => setSearchValues({ ...searchValues, postcode: e?.target?.value })}
                                />
                            </Col>

                            {/* Search Button */}
                            <Col span={3}>
                                <Button
                                    type="primary"
                                    className='btn btn-primary'
                                    onClick={handleSearch}
                                    style={{ height: '50px', width: '100%' }}
                                >
                                    Search
                                </Button>
                            </Col>
                            <Col span={3}>
                                <Button
                                    onClick={handleReset}
                                    style={{ height: '50px', width: '100%' }}
                                >
                                    Reset
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    <div className="cardContentbody">
                        {tableComponent}
                    </div>
                </div>
            </div>
            <Modal
                open={showConfirm}
                title="Are you sure you want to become referrer?"
                onOk={() => setShowConfirm(!showConfirm)}
                onCancel={() =>setShowConfirm(!showConfirm)}
                footer={[
                    <Button key="back" className='btn btn-outline-primary-md' onClick={()=> setShowConfirm(!showConfirm)}>
                        Cancel
                    </Button>,
                    <Button key="submit" className='btn btn-primary-md' type="primary" loading={isLoading} onClick={() => setShowConfirm(!showConfirm)}>
                        Ok
                    </Button>
                ]}
            >
                Once you click Ok it won't be reverted.
            </Modal>
        </div>
    );
};

export default ReferUsNetworkList;
